export default {
	props: [ "receiptLine", "orderLine" ],
	computed: {
		getDiscountLineFromOrder() {
			if(this.pendingOrder) {
				return this.pendingOrder.orderLines.find((ol) => ol.name === "Total Rabat");
			}
			return null;
		},
		getGlobalDiscountPriceRuleId() {
			const orderLine = this.orderLine ? this.orderLine : this.getDiscountLineFromOrder;
			return orderLine
				&& orderLine.options
				&& orderLine.options.appliedPriceRule
				&& orderLine.options.appliedPriceRule.options
				&& orderLine.options.appliedPriceRule.options.label === "CartDiscount"
				&& orderLine.options.appliedPriceRule.id;
		},
		getGlobalDiscountDisplayLabel() {
			const orderLine = this.orderLine ? this.orderLine : this.getDiscountLineFromOrder;
			return orderLine
				&& orderLine.options
				&& orderLine.options.appliedPriceRule
				&& orderLine.options.appliedPriceRule.options
				&& orderLine.options.appliedPriceRule.options.displayLabel;
		},
		extractlabelFromTag() {
			const self = this;
			if(!self.receiptLine) {
				return "";
			}

			return self.receiptLine.tags.length > 0 && self.receiptLine.tags[0];
		},
		extractDiscountMessageFromTag() {
			const self = this;
			if(!self.receiptLine) {
				return "";
			}

			return self.receiptLine.tags.length > 0 && self.receiptLine.tags.slice(1);
		}
	},
	methods: {
		isDiscountLine(line) {
			return ["FreeMeal", "Discount"].includes(line.type);
		},
		tagToLocalizedString(tag) {
			const self = this;

			const discountMax = this.orderLine && this.orderLine.options && this.orderLine.options.appliedPriceRule &&
				this.orderLine.options.appliedPriceRule.options && this.orderLine.options.appliedPriceRule.options.discountMax;

			switch(tag){
			case "Delivery": return "Delivery";
			case "SunsetPlusForEmployees": return self.$t("shopComponents.gt2.shoppingCart.orderDiscount.sunsetPlusForEmployees");
			case "SunsetPoints": return self.$t("shopComponents.gt2.shoppingCart.orderDiscount.sunsetPoints");
			case "SunsetPlusBasic": return self.$t("shopComponents.gt2.shoppingCart.orderDiscount.sunsetPlusBasic");
			case "SunsetPlusBusiness": return self.$t("shopComponents.gt2.shoppingCart.orderDiscount.sunsetPlusBusiness");
			case "SunsetPlusExclusive": return self.$t("shopComponents.gt2.shoppingCart.orderDiscount.sunsetPlusExclusive");
			case "SunsetPlusPremium": return self.$t("shopComponents.gt2.shoppingCart.orderDiscount.sunsetPlusPremium");
			case "Total Discount": return self.$t("shopComponents.gt2.shoppingCart.orderDiscount.totalDiscount");
			case "FreeMeal": return self.$t("shopComponents.gt2.shoppingCart.orderDiscount.freeMeal");
			case "CartDiscount": return self.getGlobalDiscountDisplayLabel || self.$t("shopComponents.gt2.shoppingCart.orderDiscount.cartDiscount");
			case "Voucher": return "Campaign code";
			case "DiscountCapped":
				if(self.extractlabelFromTag){
					switch (self.extractlabelFromTag) {
					case "SunsetPlusForEmployees": return self.$t("shopComponents.gt2.shoppingCart.orderDiscount.sunsetPlusForEmployeesMessage", { discountMaximum: discountMax || 500 });
					case "SunsetPlusBasic": return self.$t("shopComponents.gt2.shoppingCart.orderDiscount.sunsetPlusBasicMessage", { discountMaximum: discountMax || 150 });
					case "SunsetPlusBusiness": return self.$t("shopComponents.gt2.shoppingCart.orderDiscount.sunsetPlusBusinessMessage", { discountMaximum: discountMax || 150 });
					case "SunsetPlusExclusive": return self.$t("shopComponents.gt2.shoppingCart.orderDiscount.sunsetPlusExclusiveMessage", { discountMaximum: discountMax || 750 });
					case "SunsetPlusPremium": return self.$t("shopComponents.gt2.shoppingCart.orderDiscount.sunsetPlusPremiumMessage", { discountMaximum: discountMax || 750 });
					case "SunsetPoints": return self.$t("shopComponents.gt2.shoppingCart.orderDiscount.sunsetPointsMessage", { discountMaximum: discountMax || 300 });
					case "CartDiscount": return self.$t("shopComponents.gt2.shoppingCart.orderDiscount.cartDiscountMessage", { discountMaximum: discountMax || 1000 });
					default: {
						if (self.extractlabelFromTag.startsWith("FreeMeal:")) {
							const voucherName = self.extractlabelFromTag.substring("FreeMeal:".length);
							return `${voucherName} price rule applied`;
						}
					}
					}
				}
				return self.$t("shopComponents.gt2.shoppingCart.orderDiscount.discountCapped");
			}
		}
	}
};
